export const colors = {
    red: '#A70000',
    yellow: '#c7aa75',          //colore dei divider
    goldYellow: '#ffc803',      //colore del filtro della classe selezionato
    gold: '#e6b800',
    gray: '#9d9d9d',
    darkGray: '#222',           //più scuro
    lighterGray: '#cccccc',     //un pò chiaro
    lightGray: '#EEE'           //molto chiaro, usato anche per il background dell'app
}